<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">×</button>
    <h4 class="modal-title wrap-text-in" [innerHTML]="label"></h4>
</div>

<div class="modal-body">
    <div class="row px-3" *ngIf="!isSingleCandidateSelected">
        <div class="main-box" *ngIf="validCandidatesToSendOutreachEmail.length > 0">
            <div class="main-box-header">
                '<span class="emerald">Send outreach</span>' to the following Candidate(s).
            </div>
            <div class="main-box-body" style="max-height: 120px; overflow-y: scroll">
                <div class="row" *ngFor="let candidate of validCandidatesToSendOutreachEmail; let i = index">
                    <div class="col-xs-12" style="display: flex; justify-content: space-between;">
                        <div class="checkbox-nice"
                            [ngClass]="{'bg-info': !candidate.showAlert, 'bg-danger': candidate.showAlert}"
                            style="margin: 3px; padding: 3px; padding-left: 8px; border-radius: 5px; display: inline;">
                            <input type="checkbox" id="{{candidate.candidateId}}" name="{{candidate.candidateId}}"
                                style="margin:0px" [(ngModel)]="candidate.selected" />
                            <label for="{{candidate.candidateId}}"></label>
                            <strong [ngClass]="{'emerald': !candidate.showAlert, 'red': candidate.showAlert}">{{candidate.candidateName}}</strong>
                            <span>{{candidate.message}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-box" *ngIf="notValidCandidatesToSendOutreachEmail.length > 0">
            <div class="main-box-header">
                '<span class="red">Cannot Send outreach</span>' to the following Candidate(s).
            </div>
            <div class="main-box-body" style="max-height: 120px; overflow-y: scroll">
                <div class="row" *ngFor="let candidate of notValidCandidatesToSendOutreachEmail; let i = index">
                    <div class="col-xs-12" style="display: flex; justify-content: space-between;">
                        <div class="checkbox-nice"
                            [ngClass]="{'bg-info': candidate.showAlert, 'bg-danger': !candidate.showAlert}"
                            style="margin: 3px; padding: 3px; padding-left: 8px; border-radius: 5px; display: inline;">
                            <strong [ngClass]="{'emerald': candidate.showAlert, 'red': !candidate.showAlert}">{{candidate.candidateName}}</strong>
                            <span>({{candidate.message}})</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mx-2" *ngIf="!isSingleCandidateSelected">
        <p *ngIf="validCandidatesToSendOutreachEmail.length > 0">Do you want us to send the
            candidate(s) an outreach email to determine their interest?</p>
        <p *ngIf="validCandidatesToSendOutreachEmail.length === 0 && context !== 'associateCandidates'">
            Please select candidates having valid <strong>Email Id</strong>, not in <strong>Interested</strong> or <strong>Released</strong> state, and with <strong>Outreach Not Submitted</strong>.
        </p>
    </div>
    <div class="px-4 mx-2 py-4"
        *ngIf="isSingleCandidateSelected">
        <app-send-candidate-outreach-email
            [companyId]="companyId"
            [userId]="userId"
            [candidateId]="candidateId"
            [clientOrBuId]="clientOrBUId"
            [context]="context"
            (closeCallback)="closeModal()"
            [isOutreachModal]="true"
            [jobMatches]="selectedJobMatchesForOutreach"
            [candidateType]="candidateType"
            (successCallback)="saveCallback()"
            [salaryDurationOptions]="salaryDurationOptions"
            [jobTypeList]="jobTypeList">
        </app-send-candidate-outreach-email>
    </div>
</div>

<div class="modal-footer">
    <div *ngIf="validCandidatesToSendOutreachEmail.length > 0 && !isSingleCandidateSelected">
        <button type="button" class="btn btn-danger mr-2" (click)="closeModal()">No</button>
        <button type="button" class="btn btn-success" (click)="saveCallback()">Yes</button>
    </div>
    <div *ngIf="validCandidatesToSendOutreachEmail.length === 0 && !isSingleCandidateSelected">
        <button type="button" class="btn btn-success" (click)="cancelCallback()">Ok</button>
    </div>
</div>
